import styled from "styled-components";

export const DivError = styled.div`
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    h1 {
        color: #887ED8;
        margin: 10px
    }
`

export const Img = styled.img`
    height: 200px;
    margin-bottom: 20px;
`